import type { DebouncedFunc } from 'lodash';
import type { ChangeEvent, MutableRefObject } from 'react';
import type { ICostCodesItem, TCostCodesFilters } from 'src/common/interfaces/cost-codes';

interface IUpdateParams {
  id: string;
  field: keyof ICostCodesItem;
  value: string;
}

export const getRows = (
  data: ICostCodesItem[],
  filters: Partial<TCostCodesFilters>,
  costCodesCellValueUpdated: (params: IUpdateParams) => void,
  debounceUpdatedCostCodesItem: MutableRefObject<DebouncedFunc<(id: string, data: ICostCodesItem) => void>>,
  onClickDelete: (dataRow: ICostCodesItem) => void,
) => {
  const filteredData = data
    .filter((item) => item.deleted === null)
    .filter((item) =>
      Object.entries(filters).every(([key, value]) =>
        value ? item[key as keyof TCostCodesFilters]?.toString().toLowerCase().includes(value.toLowerCase()) : true,
      ),
    );

  return filteredData.map((dataRow) => {
    const rowsCells = Object.entries(dataRow)
      .filter(([key]) => key === 'code' || key === 'name')
      .map(([key, value]) => ({
        name: dataRow.costCodesId,
        value,
        type: 'Input',
        error: '',
        onChange: (ev: ChangeEvent<HTMLInputElement>) => {
          const { value } = ev.target;
          costCodesCellValueUpdated({
            id: dataRow.costCodesId as string,
            value,
            field: key as keyof ICostCodesItem,
          });
          if (value && dataRow.costCodesId) {
            debounceUpdatedCostCodesItem.current(dataRow.costCodesId, {
              ...dataRow,
              [key]: value,
            });
          }
        },
      }));

    return {
      cells: rowsCells,
      actions: [
        {
          label: 'Delete',
          icon: 'minus',
          onClick: () => onClickDelete(dataRow),
        },
      ],
    };
  });
};
